import React from 'react';
import { useHistory } from 'react-router-dom';
import Button from '@mui/material/Button';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import { useTranslation } from 'react-i18next';

const VolverButton = () => {
  const history = useHistory();
  const [t, i18n] = useTranslation("global");

  const handleClick = () => {
    history.goBack();
  };

  return (
    <Button variant="outlined" color="#141A2C" startIcon={<ArrowBackOutlinedIcon />}
      style={{margin: '5px', border: "1px solid #141A2C"}} 
      onClick={handleClick}
    >
      {t("button.back")}
    </Button>
  )
}
  
export default VolverButton;
